interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@type': 'Organization' as const,
    data: {
      name: '开云体育',
      url: 'https://www.kaiyunsports.com/',
      description: '开云体育是领先的体育竞技平台，提供赛事资讯、平台指南及完整体育娱乐服务。',
      logo: 'https://www.kaiyunsports.com/logo.png',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        telephone: '400-888-6666',
        email: 'service@kaiyunsports.com',
        availableLanguage: ['Chinese'],
      },
    },
  };
}

export function getWebSiteSchema() {
  return {
    '@type': 'WebSite' as const,
    data: {
      name: '开云体育',
      url: 'https://www.kaiyunsports.com/',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.kaiyunsports.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@type': 'WebPage' as const,
    data: {
      name: title,
      description,
      url,
      isPartOf: {
        '@type': 'WebSite',
        name: '开云体育',
        url: 'https://www.kaiyunsports.com/',
      },
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url?: string }[]) {
  return {
    '@type': 'BreadcrumbList' as const,
    data: {
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url || undefined,
      })),
    },
  };
}

export function getArticleSchema(title: string, description: string, url: string, datePublished: string, author: string, image: string) {
  return {
    '@type': 'Article' as const,
    data: {
      headline: title,
      description,
      url,
      datePublished,
      dateModified: datePublished,
      author: {
        '@type': 'Person',
        name: author,
      },
      image,
      publisher: {
        '@type': 'Organization',
        name: '开云体育',
      },
    },
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@type': 'FAQPage' as const,
    data: {
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  };
}